export enum MapLocationType {
    END = 'end',
    START = 'start',
}